<gs1-loading></gs1-loading>
<gs1-notifications></gs1-notifications>
<router-outlet></router-outlet>